import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useCurrentUserQuery } from "../../hooks/queries/useAuthQueries";
import { applyPinLockedBlock } from "./otpErrorUtils";
import { usePinLockedStore } from "../../stores/useOtpBlockStore";
import { CustomLoadingOverlay } from "../ui/CustomLoadingOverlay/CustomLoadingOverLay";

function PinLockGuard({ children, redirectOnLock }) {
  const location = useLocation();
  const { refetch } = useCurrentUserQuery({ enabled: false });
  const blockExpiresAt = usePinLockedStore((s) => s.blockExpiresAt);
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let cancelled = false;
    setStatus("checking");

    refetch()
      .then((result) => {
        if (cancelled) return;

        if (result.isError) {
          setStatus("error");
          return;
        }

        if (result.data?.pinLocked) {
          applyPinLockedBlock(result.data, usePinLockedStore, "PIN_LOCKED");
        } else {
          usePinLockedStore.getState().clearOtpBlock();
        }
        setStatus("resolved");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname, refetch]);

  if (status === "error") return null;

  if (status === "checking") {
    return (
      <div className="absolute inset-0">
        <CustomLoadingOverlay
          visible
          overlayProps={{ radius: "sm", blur: 0, backgroundOpacity: 0 }}
          loaderProps={{ color: "primary", type: "bars" }}
        />
      </div>
    );
  }

  const isLocked = !!blockExpiresAt && blockExpiresAt > Date.now();
  if (isLocked && redirectOnLock) {
    return <Navigate to={redirectOnLock} replace />;
  }

  return children;
}

export default PinLockGuard;
